import React from "react";
import moment from "moment/moment";
function EventList({ event, onViewAttendees, showAttendeesButton }) {
  const today = new Date();
  const eventDate = new Date(event.date);
  today.setHours(0, 0, 0, 0);
  eventDate.setHours(0, 0, 0, 0);

  const isUpcoming = eventDate >= today;

  return (
    <div className="flex flex-row shadow rounded-lg border border-gray-200  items-center py-2 px-3 w-full mb-2">
      {/* Event Date */}
      <div className="basis-1/4 flex flex-col">
        {isUpcoming && (
          <span className="mb-1 inline-block text-xs px-2 py-0.5 rounded-full w-fit bg-red-100 text-red-700">
            Upcoming
          </span>
        )}
        <span className="text-base font-medium text-gray-800 whitespace-nowrap overflow-hidden text-ellipsis">
          {moment(event.date).format("MM-DD-YYYY")}
        </span>
      </div>

      {/* Event Details */}
      <div className="basis-3/4 text-lg overflow-hidden text-ellipsis truncate">
        <span className="block truncate max-w-[200px] text-base font-semibold text-gray-900 uppercase">
          {event.name}
        </span>
        <span className="block break-words max-w-[300px]">
          {event.description}
          <p className="text-sm text-gray-600 break-words">
            {event.city}
            <span className="px-2 text-gray-400"> |</span>
            {event.state}
          </p>
        </span>
      </div>

      {/* Button */}
      {showAttendeesButton && (
        <div className="basis-1/4 flex justify-end items-center">
          <button
            onClick={onViewAttendees}
            className="bg-blue-700 hover:bg-blue-800 text-white px-3 py-1.5 rounded-md text-sm transition-colors"
          >
            Attendees
          </button>
        </div>
      )}
    </div>
  );
}

export default EventList;
